(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-json.js', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './ktor-ktor-http.js', './ktor-ktor-client-content-negotiation.js', './ktor-ktor-serialization-kotlinx-json.js', './ktor-ktor-client-core.js', './ktor-ktor-utils.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./ktor-ktor-http.js'), require('./ktor-ktor-client-content-negotiation.js'), require('./ktor-ktor-serialization-kotlinx-json.js'), require('./ktor-ktor-client-core.js'), require('./ktor-ktor-utils.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-oauth'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'curity-ssi-libs-oauth'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-oauth'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'curity-ssi-libs-oauth'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-oauth'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'curity-ssi-libs-oauth'.");
    }
    if (typeof this['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-oauth'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'curity-ssi-libs-oauth'.");
    }
    if (typeof this['ktor-ktor-client-content-negotiation'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-oauth'. Its dependency 'ktor-ktor-client-content-negotiation' was not found. Please, check whether 'ktor-ktor-client-content-negotiation' is loaded prior to 'curity-ssi-libs-oauth'.");
    }
    if (typeof this['ktor-ktor-serialization-kotlinx-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-oauth'. Its dependency 'ktor-ktor-serialization-kotlinx-json' was not found. Please, check whether 'ktor-ktor-serialization-kotlinx-json' is loaded prior to 'curity-ssi-libs-oauth'.");
    }
    if (typeof this['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-oauth'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'curity-ssi-libs-oauth'.");
    }
    if (typeof this['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-oauth'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'curity-ssi-libs-oauth'.");
    }
    root['curity-ssi-libs-oauth'] = factory(typeof this['curity-ssi-libs-oauth'] === 'undefined' ? {} : this['curity-ssi-libs-oauth'], this['kotlinx-serialization-kotlinx-serialization-json'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['ktor-ktor-http'], this['ktor-ktor-client-content-negotiation'], this['ktor-ktor-serialization-kotlinx-json'], this['ktor-ktor-client-core'], this['ktor-ktor-utils']);
  }
}(globalThis, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_client_content_negotiation, kotlin_io_ktor_ktor_serialization_kotlinx_json, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_utils) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var JsonElementSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.c;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
  var protoOf = kotlin_kotlin.$_$.kb;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var Unit_instance = kotlin_kotlin.$_$.h5;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var THROW_CCE = kotlin_kotlin.$_$.te;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var initMetadataForObject = kotlin_kotlin.$_$.oa;
  var VOID = kotlin_kotlin.$_$.f;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.jb;
  var toString = kotlin_kotlin.$_$.vf;
  var getStringHashCode = kotlin_kotlin.$_$.ga;
  var hashCode = kotlin_kotlin.$_$.ha;
  var equals = kotlin_kotlin.$_$.ba;
  var initMetadataForClass = kotlin_kotlin.$_$.ia;
  var THROW_IAE = kotlin_kotlin.$_$.ue;
  var Enum = kotlin_kotlin.$_$.ie;
  var defineProp = kotlin_kotlin.$_$.aa;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var parameters = kotlin_io_ktor_ktor_http.$_$.m1;
  var Plugin_getInstance = kotlin_io_ktor_ktor_client_content_negotiation.$_$.a;
  var json = kotlin_io_ktor_ktor_serialization_kotlinx_json.$_$.a;
  var CoroutineImpl = kotlin_kotlin.$_$.n9;
  var submitForm = kotlin_io_ktor_ktor_client_core.$_$.a;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
  var Exception_init_$Create$ = kotlin_kotlin.$_$.n1;
  var JsType_instance = kotlin_io_ktor_ktor_utils.$_$.b;
  var getKClass = kotlin_kotlin.$_$.e;
  var arrayOf = kotlin_kotlin.$_$.hf;
  var createKType = kotlin_kotlin.$_$.b;
  var typeInfoImpl = kotlin_io_ktor_ktor_utils.$_$.l;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
  var HttpClient = kotlin_io_ktor_ktor_client_core.$_$.v;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonOAuthSuccessTokenResponse, 'JsonOAuthSuccessTokenResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForCompanion(Companion_0);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonOAuthErrorTokenResponse, 'JsonOAuthErrorTokenResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  initMetadataForClass(OAuthResponseType, 'OAuthResponseType', VOID, Enum);
  initMetadataForCompanion(Companion_1);
  initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OAuthAuthorizationRequest, 'OAuthAuthorizationRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  initMetadataForCompanion(Companion_2);
  initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OAuthAuthorizationResponse, 'OAuthAuthorizationResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  initMetadataForClass(OAuthClient, 'OAuthClient');
  initMetadataForCoroutine($requestTokenCOROUTINE$0, CoroutineImpl);
  initMetadataForClass(OAuthCodeFlowClient, 'OAuthCodeFlowClient', VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($requestTokenCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(OAuthPreAuthorizedCodeFlowClient, 'OAuthPreAuthorizedCodeFlowClient', VOID, VOID, VOID, [2]);
  initMetadataForCoroutine($requestTokenCOROUTINE$2, CoroutineImpl);
  initMetadataForClass(OAuthRefreshFlowClient, 'OAuthRefreshFlowClient', VOID, VOID, VOID, [1]);
  //endregion
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n5u_1 = [null, null, null, null, null, new ArrayListSerializer(JsonElementSerializer_getInstance()), null, null];
  }
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.oauth.JsonOAuthSuccessTokenResponse', this, 8);
    tmp0_serialDesc.wy('token_type', false);
    tmp0_serialDesc.wy('access_token', false);
    tmp0_serialDesc.wy('refresh_token', true);
    tmp0_serialDesc.wy('expires_in', true);
    tmp0_serialDesc.wy('scope', true);
    tmp0_serialDesc.wy('authorization_details', true);
    tmp0_serialDesc.wy('c_nonce', true);
    tmp0_serialDesc.wy('c_nonce_expires_in', true);
    this.o5u_1 = tmp0_serialDesc;
  }
  protoOf($serializer).p5u = function (encoder, value) {
    var tmp0_desc = this.o5u_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance().n5u_1;
    tmp1_output.zs(tmp0_desc, 0, value.q5u_1);
    tmp1_output.zs(tmp0_desc, 1, value.r5u_1);
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.s5u_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.s5u_1);
    }
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.t5u_1 == null)) {
      tmp1_output.dt(tmp0_desc, 3, LongSerializer_getInstance(), value.t5u_1);
    }
    if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.u5u_1 == null)) {
      tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.u5u_1);
    }
    if (tmp1_output.ht(tmp0_desc, 5) ? true : !(value.v5u_1 == null)) {
      tmp1_output.dt(tmp0_desc, 5, tmp2_cached[5], value.v5u_1);
    }
    if (tmp1_output.ht(tmp0_desc, 6) ? true : !(value.w5u_1 == null)) {
      tmp1_output.dt(tmp0_desc, 6, StringSerializer_getInstance(), value.w5u_1);
    }
    if (tmp1_output.ht(tmp0_desc, 7) ? true : !(value.x5u_1 == null)) {
      tmp1_output.dt(tmp0_desc, 7, LongSerializer_getInstance(), value.x5u_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer).zn = function (encoder, value) {
    return this.p5u(encoder, value instanceof JsonOAuthSuccessTokenResponse ? value : THROW_CCE());
  };
  protoOf($serializer).ao = function (decoder) {
    var tmp0_desc = this.o5u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.lr(tmp0_desc);
    var tmp13_cached = Companion_getInstance().n5u_1;
    if (tmp12_input.as()) {
      tmp4_local0 = tmp12_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.zr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.zr(tmp0_desc, 5, tmp13_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.zr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.zr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.zr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.zr(tmp0_desc, 5, tmp13_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.zr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.zr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.mr(tmp0_desc);
    return JsonOAuthSuccessTokenResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer).yn = function () {
    return this.o5u_1;
  };
  protoOf($serializer).lz = function () {
    var tmp0_cached = Companion_getInstance().n5u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[5]), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function JsonOAuthSuccessTokenResponse_init_$Init$(seen0, tokenType, accessToken, refreshToken, expiresIn, scope, authorizationDetails, cNonce, cNonceExpiresIn, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance().o5u_1);
    }
    $this.q5u_1 = tokenType;
    $this.r5u_1 = accessToken;
    if (0 === (seen0 & 4))
      $this.s5u_1 = null;
    else
      $this.s5u_1 = refreshToken;
    if (0 === (seen0 & 8))
      $this.t5u_1 = null;
    else
      $this.t5u_1 = expiresIn;
    if (0 === (seen0 & 16))
      $this.u5u_1 = null;
    else
      $this.u5u_1 = scope;
    if (0 === (seen0 & 32))
      $this.v5u_1 = null;
    else
      $this.v5u_1 = authorizationDetails;
    if (0 === (seen0 & 64))
      $this.w5u_1 = null;
    else
      $this.w5u_1 = cNonce;
    if (0 === (seen0 & 128))
      $this.x5u_1 = null;
    else
      $this.x5u_1 = cNonceExpiresIn;
    return $this;
  }
  function JsonOAuthSuccessTokenResponse_init_$Create$(seen0, tokenType, accessToken, refreshToken, expiresIn, scope, authorizationDetails, cNonce, cNonceExpiresIn, serializationConstructorMarker) {
    return JsonOAuthSuccessTokenResponse_init_$Init$(seen0, tokenType, accessToken, refreshToken, expiresIn, scope, authorizationDetails, cNonce, cNonceExpiresIn, serializationConstructorMarker, objectCreate(protoOf(JsonOAuthSuccessTokenResponse)));
  }
  function JsonOAuthSuccessTokenResponse(tokenType, accessToken, refreshToken, expiresIn, scope, authorizationDetails, cNonce, cNonceExpiresIn) {
    Companion_getInstance();
    refreshToken = refreshToken === VOID ? null : refreshToken;
    expiresIn = expiresIn === VOID ? null : expiresIn;
    scope = scope === VOID ? null : scope;
    authorizationDetails = authorizationDetails === VOID ? null : authorizationDetails;
    cNonce = cNonce === VOID ? null : cNonce;
    cNonceExpiresIn = cNonceExpiresIn === VOID ? null : cNonceExpiresIn;
    this.q5u_1 = tokenType;
    this.r5u_1 = accessToken;
    this.s5u_1 = refreshToken;
    this.t5u_1 = expiresIn;
    this.u5u_1 = scope;
    this.v5u_1 = authorizationDetails;
    this.w5u_1 = cNonce;
    this.x5u_1 = cNonceExpiresIn;
  }
  protoOf(JsonOAuthSuccessTokenResponse).y5u = function () {
    return this.r5u_1;
  };
  protoOf(JsonOAuthSuccessTokenResponse).z5u = function () {
    return this.s5u_1;
  };
  protoOf(JsonOAuthSuccessTokenResponse).toString = function () {
    return 'JsonOAuthSuccessTokenResponse(tokenType=' + this.q5u_1 + ', accessToken=' + this.r5u_1 + ', refreshToken=' + this.s5u_1 + ', expiresIn=' + toString(this.t5u_1) + ', scope=' + this.u5u_1 + ', authorizationDetails=' + toString(this.v5u_1) + ', cNonce=' + this.w5u_1 + ', cNonceExpiresIn=' + toString(this.x5u_1) + ')';
  };
  protoOf(JsonOAuthSuccessTokenResponse).hashCode = function () {
    var result = getStringHashCode(this.q5u_1);
    result = imul(result, 31) + getStringHashCode(this.r5u_1) | 0;
    result = imul(result, 31) + (this.s5u_1 == null ? 0 : getStringHashCode(this.s5u_1)) | 0;
    result = imul(result, 31) + (this.t5u_1 == null ? 0 : this.t5u_1.hashCode()) | 0;
    result = imul(result, 31) + (this.u5u_1 == null ? 0 : getStringHashCode(this.u5u_1)) | 0;
    result = imul(result, 31) + (this.v5u_1 == null ? 0 : hashCode(this.v5u_1)) | 0;
    result = imul(result, 31) + (this.w5u_1 == null ? 0 : getStringHashCode(this.w5u_1)) | 0;
    result = imul(result, 31) + (this.x5u_1 == null ? 0 : this.x5u_1.hashCode()) | 0;
    return result;
  };
  protoOf(JsonOAuthSuccessTokenResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonOAuthSuccessTokenResponse))
      return false;
    var tmp0_other_with_cast = other instanceof JsonOAuthSuccessTokenResponse ? other : THROW_CCE();
    if (!(this.q5u_1 === tmp0_other_with_cast.q5u_1))
      return false;
    if (!(this.r5u_1 === tmp0_other_with_cast.r5u_1))
      return false;
    if (!(this.s5u_1 == tmp0_other_with_cast.s5u_1))
      return false;
    if (!equals(this.t5u_1, tmp0_other_with_cast.t5u_1))
      return false;
    if (!(this.u5u_1 == tmp0_other_with_cast.u5u_1))
      return false;
    if (!equals(this.v5u_1, tmp0_other_with_cast.v5u_1))
      return false;
    if (!(this.w5u_1 == tmp0_other_with_cast.w5u_1))
      return false;
    if (!equals(this.x5u_1, tmp0_other_with_cast.x5u_1))
      return false;
    return true;
  };
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.oauth.JsonOAuthErrorTokenResponse', this, 3);
    tmp0_serialDesc.wy('error', false);
    tmp0_serialDesc.wy('error_description', true);
    tmp0_serialDesc.wy('error_uri', true);
    this.a5v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).b5v = function (encoder, value) {
    var tmp0_desc = this.a5v_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.c5v_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.d5v_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.d5v_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.e5v_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.e5v_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_0).zn = function (encoder, value) {
    return this.b5v(encoder, value instanceof JsonOAuthErrorTokenResponse ? value : THROW_CCE());
  };
  protoOf($serializer_0).ao = function (decoder) {
    var tmp0_desc = this.a5v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return JsonOAuthErrorTokenResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_0).yn = function () {
    return this.a5v_1;
  };
  protoOf($serializer_0).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function JsonOAuthErrorTokenResponse_init_$Init$(seen0, error, errorDescription, errorUri, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_0().a5v_1);
    }
    $this.c5v_1 = error;
    if (0 === (seen0 & 2))
      $this.d5v_1 = null;
    else
      $this.d5v_1 = errorDescription;
    if (0 === (seen0 & 4))
      $this.e5v_1 = null;
    else
      $this.e5v_1 = errorUri;
    return $this;
  }
  function JsonOAuthErrorTokenResponse_init_$Create$(seen0, error, errorDescription, errorUri, serializationConstructorMarker) {
    return JsonOAuthErrorTokenResponse_init_$Init$(seen0, error, errorDescription, errorUri, serializationConstructorMarker, objectCreate(protoOf(JsonOAuthErrorTokenResponse)));
  }
  function JsonOAuthErrorTokenResponse(error, errorDescription, errorUri) {
    errorDescription = errorDescription === VOID ? null : errorDescription;
    errorUri = errorUri === VOID ? null : errorUri;
    this.c5v_1 = error;
    this.d5v_1 = errorDescription;
    this.e5v_1 = errorUri;
  }
  protoOf(JsonOAuthErrorTokenResponse).toString = function () {
    return 'JsonOAuthErrorTokenResponse(error=' + this.c5v_1 + ', errorDescription=' + this.d5v_1 + ', errorUri=' + this.e5v_1 + ')';
  };
  protoOf(JsonOAuthErrorTokenResponse).hashCode = function () {
    var result = getStringHashCode(this.c5v_1);
    result = imul(result, 31) + (this.d5v_1 == null ? 0 : getStringHashCode(this.d5v_1)) | 0;
    result = imul(result, 31) + (this.e5v_1 == null ? 0 : getStringHashCode(this.e5v_1)) | 0;
    return result;
  };
  protoOf(JsonOAuthErrorTokenResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonOAuthErrorTokenResponse))
      return false;
    var tmp0_other_with_cast = other instanceof JsonOAuthErrorTokenResponse ? other : THROW_CCE();
    if (!(this.c5v_1 === tmp0_other_with_cast.c5v_1))
      return false;
    if (!(this.d5v_1 == tmp0_other_with_cast.d5v_1))
      return false;
    if (!(this.e5v_1 == tmp0_other_with_cast.e5v_1))
      return false;
    return true;
  };
  var OAuthResponseType_code_instance;
  function values() {
    return [OAuthResponseType_code_getInstance()];
  }
  function valueOf(value) {
    if (value === 'code')
      return OAuthResponseType_code_getInstance();
    else {
      OAuthResponseType_initEntries();
      THROW_IAE('No enum constant value.');
    }
  }
  var OAuthResponseType_entriesInitialized;
  function OAuthResponseType_initEntries() {
    if (OAuthResponseType_entriesInitialized)
      return Unit_instance;
    OAuthResponseType_entriesInitialized = true;
    OAuthResponseType_code_instance = new OAuthResponseType('code', 0);
  }
  function OAuthResponseType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h5v_1 = [null, null, null, null, null, createSimpleEnumSerializer('io.curity.oauth.OAuthResponseType', values())];
  }
  protoOf(Companion_1).b1b = function () {
    return $serializer_getInstance_1();
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.oauth.OAuthAuthorizationRequest', this, 6);
    tmp0_serialDesc.wy('clientId', false);
    tmp0_serialDesc.wy('authorizationDetails', true);
    tmp0_serialDesc.wy('scope', true);
    tmp0_serialDesc.wy('state', true);
    tmp0_serialDesc.wy('redirectUri', true);
    tmp0_serialDesc.wy('responseType', false);
    this.i5v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).j5v = function (encoder, value) {
    var tmp0_desc = this.i5v_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_1().h5v_1;
    tmp1_output.zs(tmp0_desc, 0, value.client_id);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.authorization_details == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.authorization_details);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.scope == null)) {
      tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.scope);
    }
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.state == null)) {
      tmp1_output.dt(tmp0_desc, 3, StringSerializer_getInstance(), value.state);
    }
    if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.redirect_uri == null)) {
      tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.redirect_uri);
    }
    tmp1_output.bt(tmp0_desc, 5, tmp2_cached[5], value.response_type);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_1).zn = function (encoder, value) {
    return this.j5v(encoder, value instanceof OAuthAuthorizationRequest ? value : THROW_CCE());
  };
  protoOf($serializer_1).ao = function (decoder) {
    var tmp0_desc = this.i5v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.lr(tmp0_desc);
    var tmp11_cached = Companion_getInstance_1().h5v_1;
    if (tmp10_input.as()) {
      tmp4_local0 = tmp10_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.xr(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.xr(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.mr(tmp0_desc);
    return OAuthAuthorizationRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_1).yn = function () {
    return this.i5v_1;
  };
  protoOf($serializer_1).lz = function () {
    var tmp0_cached = Companion_getInstance_1().h5v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[5]];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function OAuthAuthorizationRequest_init_$Init$(seen0, clientId, authorizationDetails, scope, state, redirectUri, responseType, serializationConstructorMarker, $this) {
    if (!(33 === (33 & seen0))) {
      throwMissingFieldException(seen0, 33, $serializer_getInstance_1().i5v_1);
    }
    $this.client_id = clientId;
    if (0 === (seen0 & 2))
      $this.authorization_details = null;
    else
      $this.authorization_details = authorizationDetails;
    if (0 === (seen0 & 4))
      $this.scope = null;
    else
      $this.scope = scope;
    if (0 === (seen0 & 8))
      $this.state = null;
    else
      $this.state = state;
    if (0 === (seen0 & 16))
      $this.redirect_uri = null;
    else
      $this.redirect_uri = redirectUri;
    $this.response_type = responseType;
    return $this;
  }
  function OAuthAuthorizationRequest_init_$Create$(seen0, clientId, authorizationDetails, scope, state, redirectUri, responseType, serializationConstructorMarker) {
    return OAuthAuthorizationRequest_init_$Init$(seen0, clientId, authorizationDetails, scope, state, redirectUri, responseType, serializationConstructorMarker, objectCreate(protoOf(OAuthAuthorizationRequest)));
  }
  function OAuthAuthorizationRequest(clientId, authorizationDetails, scope, state, redirectUri, responseType) {
    Companion_getInstance_1();
    authorizationDetails = authorizationDetails === VOID ? null : authorizationDetails;
    scope = scope === VOID ? null : scope;
    state = state === VOID ? null : state;
    redirectUri = redirectUri === VOID ? null : redirectUri;
    responseType = responseType === VOID ? OAuthResponseType_code_getInstance() : responseType;
    this.client_id = clientId;
    this.authorization_details = authorizationDetails;
    this.scope = scope;
    this.state = state;
    this.redirect_uri = redirectUri;
    this.response_type = responseType;
  }
  protoOf(OAuthAuthorizationRequest).k5v = function () {
    return this.client_id;
  };
  protoOf(OAuthAuthorizationRequest).l5v = function () {
    return this.authorization_details;
  };
  protoOf(OAuthAuthorizationRequest).m5v = function () {
    return this.scope;
  };
  protoOf(OAuthAuthorizationRequest).n5v = function () {
    return this.state;
  };
  protoOf(OAuthAuthorizationRequest).o5v = function () {
    return this.redirect_uri;
  };
  protoOf(OAuthAuthorizationRequest).p5v = function () {
    return this.response_type;
  };
  protoOf(OAuthAuthorizationRequest).ba = function () {
    return this.client_id;
  };
  protoOf(OAuthAuthorizationRequest).ca = function () {
    return this.authorization_details;
  };
  protoOf(OAuthAuthorizationRequest).qj = function () {
    return this.scope;
  };
  protoOf(OAuthAuthorizationRequest).q5v = function () {
    return this.state;
  };
  protoOf(OAuthAuthorizationRequest).r5v = function () {
    return this.redirect_uri;
  };
  protoOf(OAuthAuthorizationRequest).s5v = function () {
    return this.response_type;
  };
  protoOf(OAuthAuthorizationRequest).t5v = function (clientId, authorizationDetails, scope, state, redirectUri, responseType) {
    return new OAuthAuthorizationRequest(clientId, authorizationDetails, scope, state, redirectUri, responseType);
  };
  protoOf(OAuthAuthorizationRequest).copy = function (clientId, authorizationDetails, scope, state, redirectUri, responseType, $super) {
    clientId = clientId === VOID ? this.client_id : clientId;
    authorizationDetails = authorizationDetails === VOID ? this.authorization_details : authorizationDetails;
    scope = scope === VOID ? this.scope : scope;
    state = state === VOID ? this.state : state;
    redirectUri = redirectUri === VOID ? this.redirect_uri : redirectUri;
    responseType = responseType === VOID ? this.response_type : responseType;
    return this.t5v(clientId, authorizationDetails, scope, state, redirectUri, responseType);
  };
  protoOf(OAuthAuthorizationRequest).toString = function () {
    return 'OAuthAuthorizationRequest(clientId=' + this.client_id + ', authorizationDetails=' + this.authorization_details + ', scope=' + this.scope + ', state=' + this.state + ', redirectUri=' + this.redirect_uri + ', responseType=' + this.response_type.toString() + ')';
  };
  protoOf(OAuthAuthorizationRequest).hashCode = function () {
    var result = getStringHashCode(this.client_id);
    result = imul(result, 31) + (this.authorization_details == null ? 0 : getStringHashCode(this.authorization_details)) | 0;
    result = imul(result, 31) + (this.scope == null ? 0 : getStringHashCode(this.scope)) | 0;
    result = imul(result, 31) + (this.state == null ? 0 : getStringHashCode(this.state)) | 0;
    result = imul(result, 31) + (this.redirect_uri == null ? 0 : getStringHashCode(this.redirect_uri)) | 0;
    result = imul(result, 31) + this.response_type.hashCode() | 0;
    return result;
  };
  protoOf(OAuthAuthorizationRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OAuthAuthorizationRequest))
      return false;
    var tmp0_other_with_cast = other instanceof OAuthAuthorizationRequest ? other : THROW_CCE();
    if (!(this.client_id === tmp0_other_with_cast.client_id))
      return false;
    if (!(this.authorization_details == tmp0_other_with_cast.authorization_details))
      return false;
    if (!(this.scope == tmp0_other_with_cast.scope))
      return false;
    if (!(this.state == tmp0_other_with_cast.state))
      return false;
    if (!(this.redirect_uri == tmp0_other_with_cast.redirect_uri))
      return false;
    if (!this.response_type.equals(tmp0_other_with_cast.response_type))
      return false;
    return true;
  };
  function appendParameters(_this__u8e3s4, request) {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.curity.oauth.appendParameters.<anonymous>' call
    _this__u8e3s4.w43('response_type', request.response_type.p2_1);
    _this__u8e3s4.w43('client_id', request.client_id);
    if (!(request.authorization_details == null)) {
      _this__u8e3s4.w43('authorization_details', request.authorization_details);
    }
    if (!(request.scope == null)) {
      _this__u8e3s4.w43('scope', request.scope);
    }
    var tmp0_safe_receiver = request.state;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      _this__u8e3s4.w43('state', tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = request.redirect_uri;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      _this__u8e3s4.w43('redirect_uri', tmp1_safe_receiver);
      tmp = Unit_instance;
    }
  }
  function OAuthResponseType_code_getInstance() {
    OAuthResponseType_initEntries();
    return OAuthResponseType_code_instance;
  }
  function Companion_2() {
  }
  protoOf(Companion_2).b1b = function () {
    return $serializer_getInstance_2();
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.oauth.OAuthAuthorizationResponse', this, 2);
    tmp0_serialDesc.wy('state', false);
    tmp0_serialDesc.wy('code', false);
    this.u5v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).v5v = function (encoder, value) {
    var tmp0_desc = this.u5v_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.state);
    tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.code);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_2).zn = function (encoder, value) {
    return this.v5v(encoder, value instanceof OAuthAuthorizationResponse ? value : THROW_CCE());
  };
  protoOf($serializer_2).ao = function (decoder) {
    var tmp0_desc = this.u5v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return OAuthAuthorizationResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_2).yn = function () {
    return this.u5v_1;
  };
  protoOf($serializer_2).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function OAuthAuthorizationResponse_init_$Init$(seen0, state, code, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_2().u5v_1);
    }
    $this.state = state;
    $this.code = code;
    return $this;
  }
  function OAuthAuthorizationResponse_init_$Create$(seen0, state, code, serializationConstructorMarker) {
    return OAuthAuthorizationResponse_init_$Init$(seen0, state, code, serializationConstructorMarker, objectCreate(protoOf(OAuthAuthorizationResponse)));
  }
  function OAuthAuthorizationResponse(state, code) {
    this.state = state;
    this.code = code;
  }
  protoOf(OAuthAuthorizationResponse).n5v = function () {
    return this.state;
  };
  protoOf(OAuthAuthorizationResponse).w5v = function () {
    return this.code;
  };
  protoOf(OAuthAuthorizationResponse).ba = function () {
    return this.state;
  };
  protoOf(OAuthAuthorizationResponse).ca = function () {
    return this.code;
  };
  protoOf(OAuthAuthorizationResponse).x5v = function (state, code) {
    return new OAuthAuthorizationResponse(state, code);
  };
  protoOf(OAuthAuthorizationResponse).copy = function (state, code, $super) {
    state = state === VOID ? this.state : state;
    code = code === VOID ? this.code : code;
    return this.x5v(state, code);
  };
  protoOf(OAuthAuthorizationResponse).toString = function () {
    return 'OAuthAuthorizationResponse(state=' + this.state + ', code=' + this.code + ')';
  };
  protoOf(OAuthAuthorizationResponse).hashCode = function () {
    var result = getStringHashCode(this.state);
    result = imul(result, 31) + (this.code == null ? 0 : getStringHashCode(this.code)) | 0;
    return result;
  };
  protoOf(OAuthAuthorizationResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OAuthAuthorizationResponse))
      return false;
    var tmp0_other_with_cast = other instanceof OAuthAuthorizationResponse ? other : THROW_CCE();
    if (!(this.state === tmp0_other_with_cast.state))
      return false;
    if (!(this.code == tmp0_other_with_cast.code))
      return false;
    return true;
  };
  function OAuthClient(id, redirectUri, secret) {
    this.id = id;
    this.redirectUri = redirectUri;
    this.secret = secret;
  }
  protoOf(OAuthClient).k2a = function () {
    return this.id;
  };
  protoOf(OAuthClient).u3f = function () {
    return this.redirectUri;
  };
  protoOf(OAuthClient).y5v = function () {
    return this.secret;
  };
  protoOf(OAuthClient).ba = function () {
    return this.id;
  };
  protoOf(OAuthClient).ca = function () {
    return this.redirectUri;
  };
  protoOf(OAuthClient).qj = function () {
    return this.secret;
  };
  protoOf(OAuthClient).z5v = function (id, redirectUri, secret) {
    return new OAuthClient(id, redirectUri, secret);
  };
  protoOf(OAuthClient).copy = function (id, redirectUri, secret, $super) {
    id = id === VOID ? this.id : id;
    redirectUri = redirectUri === VOID ? this.redirectUri : redirectUri;
    secret = secret === VOID ? this.secret : secret;
    return this.z5v(id, redirectUri, secret);
  };
  protoOf(OAuthClient).toString = function () {
    return 'OAuthClient(id=' + this.id + ', redirectUri=' + this.redirectUri + ', secret=' + this.secret + ')';
  };
  protoOf(OAuthClient).hashCode = function () {
    var result = getStringHashCode(this.id);
    result = imul(result, 31) + getStringHashCode(this.redirectUri) | 0;
    result = imul(result, 31) + getStringHashCode(this.secret) | 0;
    return result;
  };
  protoOf(OAuthClient).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OAuthClient))
      return false;
    var tmp0_other_with_cast = other instanceof OAuthClient ? other : THROW_CCE();
    if (!(this.id === tmp0_other_with_cast.id))
      return false;
    if (!(this.redirectUri === tmp0_other_with_cast.redirectUri))
      return false;
    if (!(this.secret === tmp0_other_with_cast.secret))
      return false;
    return true;
  };
  function createParameters($this, code, redirectUri) {
    return parameters(OAuthCodeFlowClient$createParameters$lambda(code, redirectUri, $this));
  }
  function OAuthCodeFlowClient$_httpClient$lambda($this$HttpClient) {
    var tmp = Plugin_getInstance();
    $this$HttpClient.t4u(tmp, OAuthCodeFlowClient$_httpClient$lambda$lambda);
    return Unit_instance;
  }
  function OAuthCodeFlowClient$_httpClient$lambda$lambda($this$install) {
    json($this$install);
    return Unit_instance;
  }
  function OAuthCodeFlowClient$createParameters$lambda($code, $redirectUri, this$0) {
    return function ($this$parameters) {
      $this$parameters.w43('grant_type', 'authorization_code');
      $this$parameters.w43('code', $code);
      $this$parameters.w43('redirect_uri', $redirectUri);
      $this$parameters.w43('client_id', this$0.a5w_1.id);
      $this$parameters.w43('client_secret', this$0.a5w_1.secret);
      return Unit_instance;
    };
  }
  function $requestTokenCOROUTINE$0(_this__u8e3s4, code, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l5w_1 = _this__u8e3s4;
    this.m5w_1 = code;
  }
  protoOf($requestTokenCOROUTINE$0).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 3;
            this.v8_1 = 1;
            suspendResult = submitForm(this.l5w_1.c5w_1, this.l5w_1.b5w_1, createParameters(this.l5w_1, this.m5w_1, this.l5w_1.a5w_1.redirectUri), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n5w_1 = suspendResult;
            if (!(this.n5w_1.y4v().h4g_1 === 200)) {
              throw Exception_init_$Create$('Unexpected status code for token request');
            }

            var tmp_0 = this;
            tmp_0.o5w_1 = this.n5w_1;
            this.v8_1 = 2;
            var tmp_1 = this.o5w_1.t4w();
            var tmp_2 = JsType_instance;
            var tmp_3 = getKClass(JsonOAuthSuccessTokenResponse);
            var tmp_4;
            try {
              tmp_4 = createKType(getKClass(JsonOAuthSuccessTokenResponse), arrayOf([]), false);
            } catch ($p) {
              var tmp_5;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_5 = null;
              } else {
                throw $p;
              }
              tmp_4 = tmp_5;
            }

            suspendResult = tmp_1.x4v(typeInfoImpl(tmp_2, tmp_3, tmp_4), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult instanceof JsonOAuthSuccessTokenResponse ? suspendResult : THROW_CCE();
          case 3:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 3) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function OAuthCodeFlowClient(engine, oAuthClient, tokenEndpoint) {
    this.a5w_1 = oAuthClient;
    this.b5w_1 = tokenEndpoint;
    var tmp = this;
    tmp.c5w_1 = HttpClient(engine, OAuthCodeFlowClient$_httpClient$lambda);
  }
  protoOf(OAuthCodeFlowClient).p5w = function (code, $completion) {
    var tmp = new $requestTokenCOROUTINE$0(this, code, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function OAuthPreAuthorizedCodeFlowClient$_httpClient$lambda($this$HttpClient) {
    var tmp = Plugin_getInstance();
    $this$HttpClient.t4u(tmp, OAuthPreAuthorizedCodeFlowClient$_httpClient$lambda$lambda);
    return Unit_instance;
  }
  function OAuthPreAuthorizedCodeFlowClient$_httpClient$lambda$lambda($this$install) {
    json($this$install);
    return Unit_instance;
  }
  function OAuthPreAuthorizedCodeFlowClient$requestToken$lambda($preAuthorizedCode, $txCode, this$0) {
    return function ($this$parameters) {
      $this$parameters.w43('grant_type', 'urn:ietf:params:oauth:grant-type:pre-authorized_code');
      $this$parameters.w43('pre-authorized_code', $preAuthorizedCode);
      var tmp;
      if (!($txCode == null)) {
        $this$parameters.w43('tx_code', $txCode);
        tmp = Unit_instance;
      }
      $this$parameters.w43('client_id', this$0.q5w_1.id);
      $this$parameters.w43('client_secret', this$0.q5w_1.secret);
      return Unit_instance;
    };
  }
  function $requestTokenCOROUTINE$1(_this__u8e3s4, preAuthorizedCode, txCode, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.b5x_1 = _this__u8e3s4;
    this.c5x_1 = preAuthorizedCode;
    this.d5x_1 = txCode;
  }
  protoOf($requestTokenCOROUTINE$1).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 5;
            this.v8_1 = 1;
            suspendResult = submitForm(this.b5x_1.s5w_1, this.b5x_1.r5w_1, parameters(OAuthPreAuthorizedCodeFlowClient$requestToken$lambda(this.c5x_1, this.d5x_1, this.b5x_1)), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.e5x_1 = suspendResult;
            this.f5x_1 = this.e5x_1.y4v().h4g_1;
            if (this.f5x_1 === 200) {
              var tmp_0 = this;
              tmp_0.h5x_1 = this.e5x_1;
              this.v8_1 = 3;
              var tmp_1 = this.h5x_1.t4w();
              var tmp_2 = JsType_instance;
              var tmp_3 = getKClass(JsonOAuthSuccessTokenResponse);
              var tmp_4;
              try {
                tmp_4 = createKType(getKClass(JsonOAuthSuccessTokenResponse), arrayOf([]), false);
              } catch ($p) {
                var tmp_5;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_5 = null;
                } else {
                  throw $p;
                }
                tmp_4 = tmp_5;
              }
              suspendResult = tmp_1.x4v(typeInfoImpl(tmp_2, tmp_3, tmp_4), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (this.f5x_1 === 400) {
                var tmp_6 = this;
                tmp_6.i5x_1 = this.e5x_1;
                this.v8_1 = 2;
                var tmp_7 = this.i5x_1.t4w();
                var tmp_8 = JsType_instance;
                var tmp_9 = getKClass(JsonOAuthErrorTokenResponse);
                var tmp_10;
                try {
                  tmp_10 = createKType(getKClass(JsonOAuthErrorTokenResponse), arrayOf([]), false);
                } catch ($p) {
                  var tmp_11;
                  if ($p instanceof Error) {
                    var cause_0 = $p;
                    tmp_11 = null;
                  } else {
                    throw $p;
                  }
                  tmp_10 = tmp_11;
                }
                suspendResult = tmp_7.x4v(typeInfoImpl(tmp_8, tmp_9, tmp_10), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_12 = this;
                throw Exception_init_$Create$('Unexpected status code for token response: ' + this.e5x_1.y4v().h4g_1);
              }
            }

          case 2:
            var tmp_13 = this;
            tmp_13.g5x_1 = suspendResult instanceof JsonOAuthErrorTokenResponse ? suspendResult : THROW_CCE();
            this.v8_1 = 4;
            continue $sm;
          case 3:
            var tmp_14 = this;
            tmp_14.g5x_1 = suspendResult instanceof JsonOAuthSuccessTokenResponse ? suspendResult : THROW_CCE();
            this.v8_1 = 4;
            continue $sm;
          case 4:
            return this.g5x_1;
          case 5:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 5) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function OAuthPreAuthorizedCodeFlowClient(engine, oAuthClient, tokenEndpoint) {
    this.q5w_1 = oAuthClient;
    this.r5w_1 = tokenEndpoint;
    var tmp = this;
    tmp.s5w_1 = HttpClient(engine, OAuthPreAuthorizedCodeFlowClient$_httpClient$lambda);
  }
  protoOf(OAuthPreAuthorizedCodeFlowClient).j5x = function (preAuthorizedCode, txCode, $completion) {
    var tmp = new $requestTokenCOROUTINE$1(this, preAuthorizedCode, txCode, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function createParameters_0($this, refreshToken) {
    return parameters(OAuthRefreshFlowClient$createParameters$lambda(refreshToken, $this));
  }
  function OAuthRefreshFlowClient$_httpClient$lambda($this$HttpClient) {
    var tmp = Plugin_getInstance();
    $this$HttpClient.t4u(tmp, OAuthRefreshFlowClient$_httpClient$lambda$lambda);
    return Unit_instance;
  }
  function OAuthRefreshFlowClient$_httpClient$lambda$lambda($this$install) {
    json($this$install);
    return Unit_instance;
  }
  function OAuthRefreshFlowClient$createParameters$lambda($refreshToken, this$0) {
    return function ($this$parameters) {
      $this$parameters.w43('grant_type', 'refresh_token');
      $this$parameters.w43('refresh_token', $refreshToken);
      $this$parameters.w43('client_id', this$0.k5x_1.id);
      $this$parameters.w43('client_secret', this$0.k5x_1.secret);
      return Unit_instance;
    };
  }
  function $requestTokenCOROUTINE$2(_this__u8e3s4, refreshToken, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v5x_1 = _this__u8e3s4;
    this.w5x_1 = refreshToken;
  }
  protoOf($requestTokenCOROUTINE$2).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 3;
            this.v8_1 = 1;
            suspendResult = submitForm(this.v5x_1.m5x_1, this.v5x_1.l5x_1, createParameters_0(this.v5x_1, this.w5x_1), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x5x_1 = suspendResult;
            if (!(this.x5x_1.y4v().h4g_1 === 200)) {
              throw Exception_init_$Create$('Unexpected status code for token request');
            }

            var tmp_0 = this;
            tmp_0.y5x_1 = this.x5x_1;
            this.v8_1 = 2;
            var tmp_1 = this.y5x_1.t4w();
            var tmp_2 = JsType_instance;
            var tmp_3 = getKClass(JsonOAuthSuccessTokenResponse);
            var tmp_4;
            try {
              tmp_4 = createKType(getKClass(JsonOAuthSuccessTokenResponse), arrayOf([]), false);
            } catch ($p) {
              var tmp_5;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_5 = null;
              } else {
                throw $p;
              }
              tmp_4 = tmp_5;
            }

            suspendResult = tmp_1.x4v(typeInfoImpl(tmp_2, tmp_3, tmp_4), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult instanceof JsonOAuthSuccessTokenResponse ? suspendResult : THROW_CCE();
          case 3:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 3) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function OAuthRefreshFlowClient(engine, oAuthClient, tokenEndpoint) {
    this.k5x_1 = oAuthClient;
    this.l5x_1 = tokenEndpoint;
    var tmp = this;
    tmp.m5x_1 = HttpClient(engine, OAuthRefreshFlowClient$_httpClient$lambda);
  }
  protoOf(OAuthRefreshFlowClient).p5w = function (refreshToken, $completion) {
    var tmp = new $requestTokenCOROUTINE$2(this, refreshToken, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  //region block: post-declaration
  protoOf($serializer).mz = typeParametersSerializers;
  protoOf($serializer_0).mz = typeParametersSerializers;
  defineProp(protoOf(OAuthResponseType), 'name', protoOf(OAuthResponseType).r2);
  defineProp(protoOf(OAuthResponseType), 'ordinal', protoOf(OAuthResponseType).s2);
  protoOf($serializer_1).mz = typeParametersSerializers;
  protoOf($serializer_2).mz = typeParametersSerializers;
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_2 = new Companion_2();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $io = _.io || (_.io = {});
    var $io$curity = $io.curity || ($io.curity = {});
    var $io$curity$oauth = $io$curity.oauth || ($io$curity.oauth = {});
    $io$curity$oauth.OAuthResponseType = OAuthResponseType;
    $io$curity$oauth.OAuthResponseType.values = values;
    $io$curity$oauth.OAuthResponseType.valueOf = valueOf;
    defineProp($io$curity$oauth.OAuthResponseType, 'code', OAuthResponseType_code_getInstance);
    $io$curity$oauth.OAuthAuthorizationRequest = OAuthAuthorizationRequest;
    defineProp($io$curity$oauth.OAuthAuthorizationRequest, 'Companion', Companion_getInstance_1);
    var $io = _.io || (_.io = {});
    var $io$curity = $io.curity || ($io.curity = {});
    var $io$curity$oauth = $io$curity.oauth || ($io$curity.oauth = {});
    $io$curity$oauth.OAuthAuthorizationResponse = OAuthAuthorizationResponse;
    defineProp($io$curity$oauth.OAuthAuthorizationResponse, 'Companion', Companion_getInstance_2);
    var $io = _.io || (_.io = {});
    var $io$curity = $io.curity || ($io.curity = {});
    var $io$curity$oauth = $io$curity.oauth || ($io$curity.oauth = {});
    $io$curity$oauth.OAuthClient = OAuthClient;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = JsonOAuthErrorTokenResponse;
  _.$_$.b = JsonOAuthSuccessTokenResponse;
  _.$_$.c = OAuthAuthorizationRequest;
  _.$_$.d = OAuthAuthorizationResponse;
  _.$_$.e = OAuthClient;
  _.$_$.f = OAuthCodeFlowClient;
  _.$_$.g = OAuthPreAuthorizedCodeFlowClient;
  _.$_$.h = OAuthRefreshFlowClient;
  _.$_$.i = appendParameters;
  //endregion
  return _;
}));

//# sourceMappingURL=curity-ssi-libs-oauth.js.map
